import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faMale, faHeartbeat, faDumbbell, faUsers, faMobileAlt, faShower, faStar, faWind } from '@fortawesome/free-solid-svg-icons';
import './index.css';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import BookTrialClass from '../../components/Classes';
import InputField from '../../components/TextInput/InputField';

import FitnessForm from '../fitness/fitness';
const workouts = [
    {
      title: 'Yoga',
      image: 'https://storage.googleapis.com/a1aa/image/L1lwR68vTpo9AlSmIENRFkwJwEMei1MqWRLgi3L0oeO2C0zTA.jpg',
    },
    {
      title: 'HIIT',
      image: 'https://storage.googleapis.com/a1aa/image/L1lwR68vTpo9AlSmIENRFkwJwEMei1MqWRLgi3L0oeO2C0zTA.jpg',
    },
    {
      title: 'Strength',
      image: 'https://storage.googleapis.com/a1aa/image/ZIUeznSrckUe7kGxTdk6xaHig7FhEyb6ht2eEIRKLTFyFonnA.jpg',
    },
    {
      title: 'Pilates',
      image: 'https://storage.googleapis.com/a1aa/image/nm0RxABrcVrkFJ7Y4zuG6MLxh9FHigeqKGCdpZp5ChnaB65JA.jpg',
    },
    {
      title: 'Dance',
      image: 'https://storage.googleapis.com/a1aa/image/uhvHaXEkQw6PFZupU9QWD7gLyzfHfyCnEIc7Hajh6J90C0zTA.jpg',
    },
    {
      title: 'Recovery',
      image: 'https://storage.googleapis.com/a1aa/image/yFIiwcekYegVUUKDMEDxAMQFrxGdyTmLtcSMVsNa9WE4C0zTA.jpg',
    },
  ];
const facilities = [
  {
    id: 1,
    title: 'CARDIO AREA',
    image: 'https://storage.googleapis.com/a1aa/image/vu7mmgRQft3GR6vCQ3b3px8foz9e6OlG3kwOwYvjguogErnnA.jpg',
    alt: 'Cardio area with treadmills',
    features: ['Treadmills', 'Ellipticals', 'Stationary Bikes'],
  },
  {
    id: 2,
    title: 'WEIGHT ROOM',
    image: 'https://storage.googleapis.com/a1aa/image/CixUZDk8x7qlD1nGPnYs8POG1heoJ5VzCyV3Ofj9fHWuErnnA.jpg',
    alt: 'Weight room with free weights',
    features: ['Free Weights', 'Weight Machines', 'Squat Racks'],
  },
  {
    id: 3,
    title: 'GROUP CLASSES',
    image: 'https://storage.googleapis.com/a1aa/image/J1EqADsvd24RGZtjn58KElbCeGwqnefTq80RJt4KxemUJWPPB.jpg',
    alt: 'Group class area for yoga',
    features: ['Yoga', 'Pilates', 'Zumba'],
  },
  {
    id: 4,
    title: 'SWIMMING POOL',
    image: 'https://storage.googleapis.com/a1aa/image/THdbpxn78M5mNRDFsE4Yuf1dRLtr6BgHPZkFGKW3fSJUi1zTA.jpg',
    alt: 'Swimming pool',
    features: ['Lap Pool', 'Leisure Pool', 'Aqua Aerobics'],
  },
  {
    id: 5,
    title: 'SPA & SAUNA',
    image: 'https://storage.googleapis.com/a1aa/image/2wEVfpIy7eguepeqokDzISOP9S56svD3MAxGIK8T1QD6IWPPB.jpg',
    alt: 'Spa and sauna area',
    features: ['Steam Room', 'Sauna', 'Hot Tub'],
  },
  {
    id: 6,
    title: 'TRAINING',
    image: 'https://storage.googleapis.com/a1aa/image/M2zfA7NfTzh81kG5wuU9qvptOOos0SxUoCTzwKvsi4wSi1zTA.jpg',
    alt: 'Personal training session',
    features: ['Sessions', 'Workout Plans', 'Fitness Assesment'],
  },
];
const features = [
    { icon: faMale, text: 'Dedicated Clubs for Men & Women' },
    { icon: faHeartbeat, text: 'Health & Wellness Consultants' },
    { icon: faDumbbell, text: 'Internationally-Certified Personal Trainers' },
    { icon: faUsers, text: '300+ Classes Per Week' },
    { icon: faMobileAlt, text: 'TriFit Muv, myTriFit, myZone' },
    { icon: faShower, text: 'Showers, changing rooms, and hundreds of lockers' },
    { icon: faStar, text: 'Equipment from top 5 fitness brands' },
    { icon: faWind, text: 'Pumping 60% fresh air' }
  ];
const FacilityCard = ({ title, image, alt, features }) => (
  <div className="col-md-5">
    <div className=" facility-card">
      <div className="facility-image">
        <img src={image} alt={alt} className="img-fluid" />
      </div>
      <div className="facility-content">
        <h3>{title}</h3>
        <ul>
          {features.map((feature, index) => (
            <li key={index}>
              <FontAwesomeIcon icon={faDumbbell} /> {feature}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

const GymFacilities = () => (
 <>
 <Header/>
  <div className="containers py-5">
      <h1 className="text-center workout-title mb-4">Workouts We Offer</h1>
      <p className="text-center workout-subtitle mb-5">
        Short & effective goal-based workouts that guarantee results
      </p>
      <div className="row">
        {workouts.map((workout, index) => (
          <div key={index} className="col-md-4 col-sm-6 mb-4">
            <div className="workout-card position-relative rounded-3 overflow-hidden">
              <img
                src={workout.image}
                alt={workout.title}
                className="w-100"
                style={{ height: '300px', objectFit: 'cover' }}
              />
              <div className="workout-card-title position-absolute bottom-0 start-50 translate-middle-x text-white fs-5 fw-bold p-3">
                {workout.title}
              </div>
            </div>
          </div>
        ))}
      </div>
       </div>

  <div className="containers mt-4 mb-5">
    <div className="title">GYM FACILITIES</div>
    <div className="row gx-4 gy-4"> 
  {facilities.map((facility) => (
    <FacilityCard key={facility.id} {...facility} />
  ))}
</div>

  </div>
   {/*  what to expect to this gym */}
   <div className="containers">
      <h2 className="section-title text-center mb-4">What to Expect at Fitness GYM</h2>
      <div className="row">
        {features.map((feature, index) => (
          <div key={index} className="col-md-3 col-sm-6 mb-4">
            <div className="feature d-flex flex-column justify-content-center align-items-center">
              <div className="feature-icon mb-2">
                <FontAwesomeIcon icon={feature.icon} style={{ fontSize: '36px', color: '#000' }} />
              </div>
              <div className="feature-text text-center" >
                {feature.text}
              </div>
            </div>
          </div>
        ))}
      </div>
      </div>
        
         <FitnessForm/>
         <div className='marginLR mt-4 mb-5'>
                <BookTrialClass/>
                </div>
      <Footer/>
 </>
);

export default GymFacilities;
